module.exports = __webpack_public_path__ + "img/cromwell.623489ea.webp";